import React from "react";
import { Container } from "react-bootstrap";
import fintech from "../../../../Asset/hero-fintech.svg";

const Second = () => {
  return (
    <>
      <section
        className="side-image-box-section"
        style={{ background: "var(--white-color)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2">
              <div className="info-content">
                <div className="title-paragraph">
                  Fintech Services and Design
                </div>
                <p>
                  At Codeffi, we provide website, application development and
                  website architecture. While we invest heavily in our team we
                  take pride in our work for a diverse set of clients. We want
                  to showcase the services we provide in the financial sector
                  such as web development and design projects.
                </p>
                <p>
                  This work incorporates Fintech application development, web
                  compositions, programming improvement and substantially more.
                  You can depend on our skillful engineers and configuration
                  cycles to give you the greatest work in the most proficient
                  manner while involving the state of the art innovation for the
                  best unwavering quality.
                </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1">
              <div className="info-img">
                <img alt="infoImage" src={fintech} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
